import { combineReducers } from 'redux';
import { LOGOUT_SUCCESS } from 'constants/ActionTypes';
import AuthenticationReducers from './reducer_authentication';
import DomainReducers from './reducer_domain';
import ImplementationReducers from './reducer_implementation';
import LiteralReducers from './reducer_literal';
import RolesReducers from './reducer_roles';
import SandboxReducers from './reducer_sandbox';
import SectionFiltersReducers from './reducer_sectionFilters';
import ServerListReducers from './reducer_serverList';
import UsersReducer from './reducer_users';
import ApiKeysReducer from './reducer_apiKeys';
import PermissionsReducer from './reducer_permission';
import DeviceCacheReducer from './reducer_deviceCache';

const appReducer = combineReducers({
    authentication: AuthenticationReducers,
    domain: DomainReducers,
    implementations: ImplementationReducers,
    literal: LiteralReducers,
    roles: RolesReducers,
    sandbox: SandboxReducers,
    sectionFilters: SectionFiltersReducers,
    serverList: ServerListReducers,
    users: UsersReducer,
    apiKeys: ApiKeysReducer,
    permissions: PermissionsReducer,
    deviceCache: DeviceCacheReducer,
});

const rootReducer = (state, action) => {
    let finalState = state;
    if (action.type === LOGOUT_SUCCESS) {
        finalState = { literal: state.literal };
    }
    return appReducer(finalState, action);
};

export default rootReducer;
